import { render, staticRenderFns } from "./batchTemplateManagementDialog.vue?vue&type=template&id=03dad36c&"
import script from "./batchTemplateManagementDialog.vue?vue&type=script&lang=js&"
export * from "./batchTemplateManagementDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03dad36c')) {
      api.createRecord('03dad36c', component.options)
    } else {
      api.reload('03dad36c', component.options)
    }
    module.hot.accept("./batchTemplateManagementDialog.vue?vue&type=template&id=03dad36c&", function () {
      api.rerender('03dad36c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/batchTemplateManagementDialog.vue"
export default component.exports